import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import JourneyReporting from './index';
import journeyBuilderStore from '../../stores/journeyBuilderStore';

export default props => (
  <BrowserRouter>
    <Provider store={journeyBuilderStore(props)}>
      <Switch>
        <Route
          path="/journey/:journeyId/reporting"
          component={JourneyReporting}
        />
      </Switch>
    </Provider>
  </BrowserRouter>
);
